import LocalizedStrings from 'react-localization';

import English from './English';
import Dutch from './Dutch';
import German from './German';
import French from './French';

const TextStrings = new LocalizedStrings({
  en: English,
  nl: Dutch,
  de: German,
  fr: French,
});

export default TextStrings;
